import BlockNewCustomer from '@/components/blocks/Customers/BlockNewCustomer';
import BlockAllCustomers from '@/components/blocks/Customers/BlockAllCustomers';
import BlockLeadsDashboard from '@/components/blocks/Customers/BlockLeadsDashboard';
import BlockCustomerProperties from '@/components/blocks/Customers/BlockCustomerProperties';
import SuperAdminGuard from '@/services/RouteGuards/SuperAdmin';
import BlockArchivedCustomers from '@/components/blocks/Customers/BlockArchivedCustomers';
import BlockDeletedCustomers from '@/components/blocks/Customers/BlockDeletedCustomers';

export default [
	{
		path: 'customers',
		name: 'CustomersAdmin',
		component: BlockAllCustomers,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Customers - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/archived',
		name: 'ArchivedCustomersAdmin',
		component: BlockArchivedCustomers,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Archived Customers - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/deleted',
		name: 'DeletedCustomersAdmin',
		component: BlockDeletedCustomers,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Deleted Customers - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/new',
		name: 'NewCustomerAdmin',
		component: BlockNewCustomer,
		props: {
			edit: false,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `New Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/single/:id',
		name: 'SingleCustomerPropertiesAdmin',
		component: BlockCustomerProperties,
		props: {
			edit: false,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Single Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/edit/:id',
		name: 'EditCustomerAdmin',
		component: BlockNewCustomer,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Edit Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/clone/:id',
		name: 'CloneCustomerAdmin',
		component: BlockNewCustomer,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Clone Customer - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'customers/leads-dashboard',
		name: 'LeadsDashboardAdmin',
		component: BlockLeadsDashboard,
		props: {
			flag: {
				type: String,
				required: false
			},
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Leads dashboard - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	}
];
